export const TOGGLE_TARIFF_CONSTRUCTOR = 'toggle tariff constructor';
export const GET_TARIFF_RESTS = 'get tariff rests';
export const CHANGE_STEP = 'change tariff constructor step';
export const GET_TARIFF_CONSTRUCTORS = 'get tariff constructors';
export const TOGGLE_FLIP_STATE = 'toggle flipped state';
export const SET_VALUES = 'set values';
export const RESET_VALUES = 'reset values';
export const CHOOSE_CONSTRUCTOR = 'choose constructor';
